<template>
  <div class="p-week">
    <cols>
      <template v-slot:left>
        <v-card
          class="diary__select-day"
        >
          {{ $t('msg.day') }}
          <day-select
            :value="selectedDay"
            @input="changeDay($event)"
          ></day-select>
        </v-card>
        <div class="pt-4">
          <week-plan
            :projects="projects"
            :notes="notes"
            :selected-day="selectedDay"
          ></week-plan>
        </div>
      </template>
    </cols>
  </div>
</template>

<script>
import DaySelect from "@/components/ui/DaySelect";
import Cols from "../../components/ui/Cols";
import WeekPlan from "@/components/block/Diary/WeekPlan";

export default {
  components: {DaySelect, Cols, WeekPlan},
  data() {
    return {
      selectedDay: this.$store.state.diary.selectedDay,
      projects: [],
      notes: [],
    };
  },
  methods: {
    changeDay(v) {
      this.selectedDay = v;
      this.$store.commit('setSelectedDay', v);
      if (this.$refs.dayPlan !== undefined) {
        this.$refs.dayPlan.loadDayPlans();
      }
    },
    loadProjects() {
      this.$store.dispatch('loadProjects')
        .then(res => this.projects = res);
    },
    loadNotes() {
      this.$store.dispatch('loadNotes')
        .then(res => this.notes = res);
    },
  },
  created() {
    this.loadProjects();
    this.loadNotes();
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/vars';

.diary__select-day {
  text-transform: capitalize;
  padding: 5px 16px;
  background-color: $colorSecondary !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
}
</style>